// TODO: Cleanup these, validate where called and then change to reject with Error objects
/* eslint-disable @typescript-eslint/prefer-promise-reject-errors */

import callGraphQLApi, {
  createGraphQLFailureAction,
  createGraphQLSuccessAction,
} from './callGraphQLApi';
import { Thunk } from '@worker/services/interfaces';
import { RedactedMediaAsset } from '@common-modules/mediaDetails/models';

// ACTIONS
export const FETCH_INTEGRATION_INFO = 'govqa/FETCH_INTEGRATION_INFO';
export const FETCH_INTEGRATION_INFO_SUCCESS =
  createGraphQLSuccessAction<FetchIntegrationInfoResponse>(
    'govqa/FETCH_INTEGRATION_INFO_SUCCESS'
  );
export const FETCH_INTEGRATION_INFO_FAILURE = createGraphQLFailureAction(
  'govqa/FETCH_INTEGRATION_INFO_FAILURE'
);

interface AuthReqPayload {
  baseUrl: string;
  activationKey: string;
  authKey: string;
  login: string;
  password: string;
}

export const auth = (authReqPayload: AuthReqPayload) => {
  const { baseUrl, authKey, activationKey, ...loginInfo } = authReqPayload;

  return new Promise<{ current_session_id: string }>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const url = `${baseUrl}/MobileUserLoginAdmin?authKey=${authKey}&activationKey=${activationKey}`;

    xhr.onerror = () => {
      console.log('xhr.response', xhr);
      reject();
    };

    xhr.ontimeout = () => {
      reject();
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300 && xhr.response) {
        resolve(JSON.parse(xhr.response));
      } else {
        reject(xhr.statusText);
      }
    };

    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.send(JSON.stringify(loginInfo));
  });
};

export interface SendFileReqPayload {
  sessionId: string;
  uniqueId: string;
  mediaFile: Pick<RedactedMediaAsset, 'name' | 'signedUri' | 'contentType'>;
  auditLog?: Pick<RedactedMediaAsset, 'name' | 'signedUri' | 'contentType'>;
  activationKey: string;
  baseUrl: string;
}

function addFilenameSuffix<T extends Pick<RedactedMediaAsset, 'name'>>(
  file: T,
  suffix: string
): T {
  if (file.name) {
    const fn = file.name.split('.');
    fn[0] += suffix;
    return {
      ...file,
      name: fn.join('.'),
    };
  }
  return file;
}

export const sendFile = (sendFileReqPayload: SendFileReqPayload) => {
  const {
    sessionId,
    uniqueId, // gov qa request id that we get on ingestion
    mediaFile: mediaFileRaw,
    auditLog: auditLogRaw,
    activationKey,
    baseUrl,
  } = sendFileReqPayload;

  const mediaFile = addFilenameSuffix(mediaFileRaw, '_redacted');
  const auditLog =
    auditLogRaw && addFilenameSuffix(auditLogRaw, '_redactionlog');

  return new Promise((resolve, reject) => {
    const xmlhttp = new XMLHttpRequest();
    const files = [mediaFile, auditLog].filter(
      (file): file is RedactedMediaAsset => !!file
    );
    const url = `${baseUrl}/UploadVideoFileAdmin`;

    xmlhttp.onerror = () => {
      console.log('xmlhttp.response', xmlhttp);
      reject();
    };

    xmlhttp.ontimeout = () => {
      reject();
    };

    xmlhttp.onload = () => {
      if (xmlhttp.status >= 200 && xmlhttp.status < 300) {
        resolve(null /* JSON.parse(xmlhttp.response)*/); // actual API doesn't return a json here
      } else {
        reject(xmlhttp.statusText);
      }
    };

    xmlhttp.open('POST', url);
    xmlhttp.setRequestHeader('Content-Type', 'application/json');
    xmlhttp.setRequestHeader('Accept', 'application/json');
    xmlhttp.send(
      JSON.stringify({
        sessionId,
        activationKey,
        uniqueId,
        files: files.map(({ name, signedUri, contentType }) => ({
          name,
          uri: signedUri,
          contentType,
        })),
      })
    );
  });
};

export interface FetchIntegrationInfoResponse {
  me: {
    organization: {
      id: string;
      integrationConfig?: {
        config: Record<string, string>;
      };
    };
  };
}
export const fetchIntegrationInfo: Thunk<void, FetchIntegrationInfoResponse> =
  () => async (dispatch, getState) => {
    const query = `
      query getGovQAIntegrationInfo {
        me {
          organization {
            id
            integrationConfig(id: "GovQA") {
              config
            }
          }
        }
      }
    `;

    return await callGraphQLApi<FetchIntegrationInfoResponse>({
      actionTypes: [
        FETCH_INTEGRATION_INFO,
        FETCH_INTEGRATION_INFO_SUCCESS,
        FETCH_INTEGRATION_INFO_FAILURE,
      ],
      query,
      variables: {},
      dispatch,
      getState,
      bailout: undefined,
    });
  };
